module.exports = __webpack_public_path__ + "img/syringe.81adcda2.svg";